import { render, staticRenderFns } from "./WorkFlowListCard.vue?vue&type=template&id=0b1ed9cc&scoped=true"
import script from "./WorkFlowListCard.vue?vue&type=script&lang=js"
export * from "./WorkFlowListCard.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowListCard.vue?vue&type=style&index=0&id=0b1ed9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ed9cc",
  null
  
)

export default component.exports